import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { ToastCard } from "@/components/ui/ToastCard"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...rest }) {
        const { variant, ...toastProps } = rest as any
        return (
          <Toast key={id} {...toastProps}>
            <ToastCard title={title} description={description} variant={variant as any} action={action} />
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
